import { IS_CORRESPONDENCE_STATE_SELECTED, IS_OFFICE_STATE_SELECTED, SET_CAPACITY_ALL,SET_CAPACITY_SELECTED_DETAILS,SET_PROFILE_DETAILS} from './types';
import { apiCall } from '../../components/Services/Interceptor';
import { toast } from 'react-toastify';
import { toastProperties } from '../../commons/Toast/Toaster';
import capacityGeneratorService from '../../components/Services/capacityGenerator.service';
import companyDetailsService from '../../components/Services/companyDetails.service';
import stateCityService from '../../components/Services/stateCity.service';

export const getAllGeneratorCapacities = () => async (dispatch) => {
    let result = {}
    try {
      const response = await capacityGeneratorService.getAllGeneratorCapacity();
  
      if (response.data.code === 200) {
        result.capacitiesList = response.data.data
        dispatch({ type: SET_CAPACITY_ALL, payload: result});
        toast.success(response.data.message, toastProperties);
      } else {
        toast.error(response.data.error, toastProperties);
      }
    } catch (error) {
      console.error('API call error:', error);
    }
  };
  export const getProfileDetails = (id) => async (dispatch) => {
    try {
      const response = await companyDetailsService.getProfileDetailsById(id);
  
      if (response.data.code === 200) {
       
        dispatch({ type: SET_PROFILE_DETAILS, payload:response.data.data});
        // toast.success(response.data.message, toastProperties);
      } else {
        toast.error(response.data.error, toastProperties);
      }
    } catch (error) {
      console.error('API call error:', error);
    }
  };

  export const getSelectedCapacityData = (data) => async (dispatch) => {

        dispatch({ type: SET_CAPACITY_SELECTED_DETAILS, payload:data});
        // toast.success(response.data.message, toastProperties);
  };

  export const getCitiesByOfficeState = async (data, dispatch) =>
    await stateCityService.getCityByState(data)
        .then((response) => {
            if (response && response?.data?.code === 200) {
                dispatch({ type: IS_OFFICE_STATE_SELECTED, payload: response?.data?.data })
            }
        }).catch(err => {
            err?.error && toast.error(err.error, toastProperties);
            console.log(err)
        });
        export const getCitiesByCorrespondenceState = async (data, dispatch) =>
    await stateCityService.getCityByState(data)
        .then((response) => {
            if (response && response?.data?.code === 200) {
                dispatch({ type: IS_CORRESPONDENCE_STATE_SELECTED, payload: response?.data?.data })
            }
        }).catch(err => {
            err?.error && toast.error(err.error, toastProperties);
            console.log(err)
        });